"use client";

import { useEffect, useState } from "react";

const defaultImage =
  "https://biome.immutable.com/hosted-assets/images/cloudImageDefaultImage--onDark.svg";

export interface ImageWithOverlayProps {
  src: string;
  alt: string;
  overlaySrc?: string;
  width?: string;
  height?: string;
  mt?: string;
  mb?: string;
  overlayWidth?: string;
  overlayHeight?: string;
  overlayTop?: string;
  overlayLeft?: string;
  overlayTransform?: string;
}

export function ImageWithOverlay({
  src,
  alt,
  overlaySrc,
  width = "128px",
  height = "128px",
  mt,
  mb = "12px",
  overlayWidth = "77px",
  overlayHeight = "95px",
  overlayTop = "55px",
  overlayLeft = "90px",
  overlayTransform = "0",
}: ImageWithOverlayProps) {
  const [mainImageSrc, setMainImageSrc] = useState<string>(src);

  useEffect(() => {
    setMainImageSrc(src);
  }, [src]);

  return (
    <div
      className="flex justify-center relative"
      style={{
        width,
        height,
        marginTop: mt,
        marginBottom: mb,
      }}
    >
      <img
        src={mainImageSrc}
        alt={alt}
        width={width}
        height={height}
        className="rounded-lg"
        onError={() => {
          setMainImageSrc(defaultImage);
        }}
      />
      {overlaySrc && (
        <img
          src={overlaySrc}
          alt="Overlay"
          className="absolute"
          style={{
            top: overlayTop,
            left: overlayLeft,
            width: overlayWidth,
            height: overlayHeight,
            transform: overlayTransform,
          }}
        />
      )}
    </div>
  );
}
